@if (label()) {
  <ui-form-field-label [label]="label()!" [addons]="labelAddons()" />
}

<mat-form-field [ngClass]="[fullWidthClass()]">
  <ui-form-field-addon matPrefix [innerContent]="innerPrefix()" [outerContent]="prefix()" [position]="'start'" />

  <!-- Input Element -->
  <input
    id="form-field-input"
    matInput
    [type]="fieldType()"
    [placeholder]="displayPlaceholder() || ''"
    [readonly]="readonly()"
    [required]="required()"
    [autocomplete]="autocomplete()"
    [formControl]="activeFormControl()"
    (input)="onInputChange($event)"
    (blur)="onInputBlur()" />

  <ui-form-field-addon matSuffix [innerContent]="innerSuffix()" [outerContent]="suffix()" [position]="'end'" />

  @if (hint() || rightHint()) {
    <mat-hint
      ><ui-form-field-hint
        [hint]="hint()"
        [rightHint]="rightHint()"
        [hintInfo]="hintInfo()"
        [rightHintInfo]="rightHintInfo()"
    /></mat-hint>
  }

  <!-- Error Messages -->
  @for (error of visibleErrors(); track error) {
    <mat-error>
      <ui-icon [size]="16" icon="griddy-alert-triangle" />
      <span>{{ error }}</span>
    </mat-error>
  }
</mat-form-field>
